<template>
    <div>
        <div class="title">The winners</div>
        <div class="scrollText" id="scrollText">
            <ul class="ul" id="scrollText1">
                <li class="textrow" v-for="(item,index) in list" v-bind:key="index">
                    <span>{{item.run_time}}</span>
                    <span>{{item.award_user.nickname}}</span>
                    <!--<span>{{item.award_user.level}}</span>-->
                </li>
            </ul>
            <div id="scrollText2"></div>
        </div>

    </div>

</template>

<script>
    export default {
        name: "scrollText",
        props: {
            list: {
                type: Array,
                default: () => []
            },

        },
        mounted(){
            var speed = 60
            // 向上滚动
            var demo = document.getElementById("scrollText");
            var demo2 = document.getElementById("scrollText2");
            var demo1 = document.getElementById("scrollText1");
            demo2.innerHTML = demo1.innerHTML

            function Marquee() {
                if (demo.scrollTop >= demo1.offsetHeight + 20) {
                    demo.scrollTop = 0;
                } else {
                    demo.scrollTop = demo.scrollTop + 1;
                }
            }
            var MyMar = setInterval(Marquee, speed)
            demo.onmouseover = function() {
                clearInterval(MyMar)
            }
            demo.onmouseout = function() {
                MyMar = setInterval(Marquee, speed)
            }
        }
    }
</script>

<style scoped>
    .title{
        font-size: 0.3rem;
        color: #282828;
        height: 0.86rem;
        width: 100%;
        background-color: #fff;
        text-align: center;
        line-height: 0.86rem;
        margin-top: 0.28rem;
    }
    .scrollText{
        width: 100%;
        max-height: 100px;
        overflow: hidden;
        padding: 0.28rem;
        box-sizing: border-box;
    }
    .scrollText .ul{
    }
    .textrow{
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
</style>
